import { createAction } from "typesafe-actions";

import type { IWorkspace } from "app/services/workspaces/workspaceApi.types";

export const toggleRightBar = createAction("@@sales/common/TOGGLE_RIGHT_BAR")<boolean>();

export const setWidgetIdRightBar = createAction("@@sales/common/SET_WIDGET_ID_RIGHT_BAR")<string | undefined>();

export const setWorkspacesListAction = createAction("@@sales/common/SET_WORKSPACES_LIST")<IWorkspace[]>();
